import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import JobCard from './JobCard';
import { formatDateKey, formatDayName, formatShortDate } from './dateUtils';
import style from './DayColumn.module.sass';

const DayColumn = ({ date, jobs, onOpenDetail }) => {
  const dateKey = formatDateKey(date);
  const totalTrigs = jobs.reduce((sum, job) => sum + (job.trigs || 0), 0);

  return (
    <div className={style.dayColumn}>
      <div className={style.header}>
        <span className={style.dayName}>{formatDayName(date)}</span>
        <span className={style.date}>{formatShortDate(date)}</span>
      </div>

      <Droppable droppableId={dateKey}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`${style.jobsContainer} ${snapshot.isDraggingOver ? style.dragOver : ''}`}
          >
            {jobs.map((job, index) => (
              <Draggable
                key={job.id.toString()}
                draggableId={job.id.toString()}
                index={index}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <JobCard
                      job={job}
                      isDragging={snapshot.isDragging}
                      onOpenDetail={onOpenDetail}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      <div className={style.footer}>
        <span className={style.trigsTotal}>{totalTrigs}</span>
      </div>
    </div>
  );
};

export default DayColumn;
